import React from 'react';
import PropTypes from 'prop-types';

const PersonalContact = props => (
    <div className="row">
        <br />
        <h4 className="info-text">Personal Contact</h4>
        <br />
        <div className="col-sm-6">
            <div className="form-group">
                <label>Contact Number <small style={{ color: 'red' }}>(required)</small></label>
                <input
                    name="Contact_Number__c"
                    id="Contact_Number__c"
                    type="text"
                    value={props.form.Contact_Number__c}
                    className={`form-control valid select ${props.errorMessage.Contact_Number__c ? 'need-fix' : ''}`}
                    onChange={props.onInputChanged}
                />
                <p className="error-message">{props.errorMessage.Contact_Number__c}</p>
            </div>
            <div className="form-group">
                <label>Mobile Phone  <small style={{ color: 'red' }}>(required)</small></label>
                <input
                    name="Mobile_Phone__c"
                    id="Mobile_Phone__c"
                    value={props.form.Mobile_Phone__c}
                    type="tel"
                    className={`form-control valid select ${props.errorMessage.Mobile_Phone__c ? 'need-fix' : ''}`}
                    onChange={props.onInputChanged}
                />
                <p className="error-message">{props.errorMessage.Mobile_Phone__c}</p>
            </div>
            <div className="form-group">
                <label>Email Address</label>
                <input
                    name="Email_Address__c"
                    id="Email_Address__c"
                    value={props.form.Email_Address__c}
                    type="text"
                    className={`form-control valid select ${props.errorMessage.Email_Address__c ? 'need-fix' : ''}`}
                    onChange={props.onInputChanged}
                />
                <p className="error-message">{props.errorMessage.Email_Address__c}</p>
            </div>
        </div>
        <div className="col-sm-6">
            <div className="form-group">
                <label>Office Phone</label>
                <input
                    name="Office_Number__c"
                    value={props.form.Office_Number__c}
                    id="Office_Phone__c"
                    type="tel"
                    className={`form-control valid select ${props.errorMessage.Office_Number__c ? 'need-fix' : ''}`}
                    onChange={props.onInputChanged}
                />
                <p className="error-message">{props.errorMessage.Office_Number__c}</p>
            </div>
            <div className="form-group">
                <label>Home Phone</label>
                <input
                    name="Home_Phone__c"
                    id="Home_Phone__c"
                    value={props.form.Home_Phone__c}
                    type="tel"
                    className={`form-control valid select ${props.errorMessage.Home_Phone__c ? 'need-fix' : ''}`}
                    onChange={props.onInputChanged}
                />
                <p className="error-message">{props.errorMessage.Home_Phone__c}</p>
            </div>
        </div>
    </div>
);

PersonalContact.propTypes = {
    form: PropTypes.object.isRequired,
    onInputChanged: PropTypes.func.isRequired,
    errorMessage: PropTypes.object.isRequired,
};

export default PersonalContact;


//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Registration/Tab2/PersonalContact.js
// module id = 1012
// module chunks = 0